document.addEventListener('DOMContentLoaded', function() {
  const scrollTextBlock = document.querySelector('[class*="text_6VVL6m"]');
  
  // Chercher la section produits recommandés de plusieurs façons
  const productsSection = document.querySelector('[id*="product_recommendations"]') ||
                         document.querySelector('[class*="product-recommendations"]') ||
                         document.querySelector('.product-list') ||
                         document.querySelector('[id*="product_list"]');
  
  if (!scrollTextBlock) return;
  
  console.log('Bloc texte trouvé:', scrollTextBlock);
  console.log('Section produits trouvée:', productsSection);
  
 // Masquer les produits recommandés initialement avec flou
if (productsSection) {
  productsSection.style.opacity = '0';
  productsSection.style.transform = 'translateY(30px)';
  productsSection.style.filter = 'blur(10px)';
  productsSection.style.transition = 'opacity 0.0s ease, transform 1.8s ease, filter 2.8s ease';
}
  
  // Sauvegarder le contenu HTML original
  const originalHTML = scrollTextBlock.innerHTML;
  let hasAnimated = false;
  
// Fonction pour faire apparaître les produits
function showProducts() {
  console.log('Affichage des produits...');
  if (productsSection) {
    setTimeout(() => {
      productsSection.style.opacity = '1';
      productsSection.style.transform = 'translateY(0)';
      productsSection.style.filter = 'blur(0px)';
    }, 300);
  }
}
  
  // Fonction typewriter
  function typewriterOnScroll(block, onComplete) {
    const textNodes = [];
    function getTextNodes(node) {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        textNodes.push(node);
      } else {
        node.childNodes.forEach(child => getTextNodes(child));
      }
    }
    getTextNodes(block);
    
    const originalTexts = textNodes.map(node => node.textContent);
    textNodes.forEach(node => node.textContent = '');
    
    let nodeIndex = 0;
    let charIndex = 0;
    
    function typeChar() {
      if (nodeIndex < textNodes.length) {
        const currentNode = textNodes[nodeIndex];
        const fullText = originalTexts[nodeIndex];
        
        if (charIndex < fullText.length) {
          currentNode.textContent += fullText.charAt(charIndex);
          charIndex++;
          setTimeout(typeChar, 15);
        } else {
          nodeIndex++;
          charIndex = 0;
          setTimeout(typeChar, 40);
        }
      } else {
        console.log('Typewriter terminé');
        if (onComplete) {
          setTimeout(onComplete, 300);
        }
      }
    }
    
    typeChar();
  }
  
  // Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasAnimated) {
        console.log('Animation démarrée');
        scrollTextBlock.innerHTML = originalHTML;
        
        setTimeout(() => {
          typewriterOnScroll(scrollTextBlock, showProducts);
        }, 200);
        
        hasAnimated = true;
      }
    });
  }, {
    threshold: 0.3
  });
  
  observer.observe(scrollTextBlock);
});

document.addEventListener('DOMContentLoaded', function() {
  // Cibler le bloc de texte spécifique avec sa classe complète
  const typewriterBlock = document.querySelector('.text-block--AQ3J5TmJlV1Y5VFFTT__text_mgiHy9');
  
  if (typewriterBlock) {
    typewriterBlock.classList.add('typewriter-text');
    
    const typeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('typing')) {
          entry.target.classList.add('typing');
          typeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    typeObserver.observe(typewriterBlock);
  }
});

